<template>
  <div>
    <div class="w-full h-full flex flex-col gap-y-3">
      <HeaderTypo as="h4" class="text-xl">{{ $t('EmirateIdentityQuestion') }}</HeaderTypo>

      <div class="w-full flex gap-x-4">
        <button
          :class="[selectedAnswer === true ? 'border-primary bg-primary' : 'border-brand-gray-600']"
          class="rounded-md border px-16 flex flex-col items-center justify-center gap-y-4 aspect-video hover:text-primary hover:border-primary bg-brand-gray-150"
          @click="$emit('onStep1Answer', true)"
        >
          <span :class="{ 'text-white': selectedAnswer === true }">{{ $t('yes') }}</span>
        </button>
        <button
          :class="[
            selectedAnswer === false ? 'border-primary bg-primary' : 'border-brand-gray-600'
          ]"
          class="rounded-md border px-62 flex flex-col items-center justify-center gap-y-4 aspect-video hover:text-primary hover:border-primary bg-brand-gray-150"
          @click="$emit('onStep1Answer', false)"
        >
          <span :class="{ 'text-white': selectedAnswer === false }">{{ $t('no') }}</span>
        </button>
      </div>
    </div>
    <ModalVue v-model="modal" containerClass="w-[24rem] md:w-[32rem]" :title="$t('Confirmation')">
      <template #bodyContent>
        <p class="leading-relaxed">{{ $t('registrationNote') }}</p>
      </template>
      <template #footerContent>
        <div class="w-full flex justify-between pb-1">
          <button
            class="rounded-md bg-gray-400/80 hover:bg-gray-400 px-3 py-1.5"
            @click="modal = false"
          >
            <div class="w-full flex gap-x-2">
              <faTimes class="w-3 fill-white" />
              <span class="ltr:font-sans tracking-wide flex-1 text-white text-sm">
                {{ $t('Close') }}
              </span>
            </div>
          </button>
          <button
            class="rounded-md bgbr bg-brand-green/80 hover:bg-brand-green px-3 py-1.5"
            @click="modal = true"
          >
            <div class="w-full flex gap-x-2">
              <faCheck class="w-3 fill-white" />
              <span class="ltr:font-sans tracking-wide flex-1 text-white text-sm">
                {{ $t('Confirm') }}
              </span>
            </div>
          </button>
        </div>
      </template>
    </ModalVue>
  </div>
</template>

<script setup>
import ModalVue from '@/components/Ui/Modal/index.vue'
import faCheck from '@/assets/icons/faCheck.svg?component'
import faTimes from '@/assets/icons/faTimes.svg?component'
import { ref, watch } from 'vue'
import router from '@/router'

const modal = ref(null)
const selectedAnswer = ref(null)

watch(modal, (newValue) => {
  if (newValue === false) {
    document.body.style.overflow = 'inherit'
    router.replace('/')
  }
})
</script>

<style lang="scss" scoped></style>
